import React from 'react';
import { AlertTriangleIcon, FrownIcon } from 'lucide-react';
export function PainSections() {
  return <section className="bg-paper px-4 py-6 sm:py-8" data-id="element-142" data-mp="3omh9r4dfs15u">
      <div className="mx-auto grid max-w-5xl gap-3 md:grid-cols-2" data-id="element-143" data-mp="3op3fcygro6lf">
        <article className="rounded-xl border-l-4 border-alert bg-white p-4 shadow-sm sm:p-5" data-id="element-144" data-mp="3jug0lrbkeqk1">
          <h2 className="flex items-start gap-2 text-xl text-navy sm:text-2xl" data-id="element-145" data-mp="3ew651flxhnxw">
            <AlertTriangleIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-146" data-mp="3avm5k5dvu88l" />
            STOP GUESSING WHAT&apos;S CAUSING THE PROBLEM
          </h2>
          <p className="mt-2 text-sm font-medium leading-snug text-ink/80 sm:text-base" data-id="element-147" data-mp="30xy0ommkbkcp">
            Check Engine Light? No-start, rough idle or electrical problem?
            Sensor, wiring, ignition, fuel system... where do you test first?
            AUTOMOTIVE DIAGNOSTIC PRO™ gives you an organized visual diagnostic
            system to help you move from symptom to possible cause with a
            clearer testing path.
          </p>
          <p className="mt-1.5 font-display text-lg uppercase tracking-wide text-auto" data-id="element-148" data-mp="2adcdq5al9lge">
            Scan. Test. Isolate.
          </p>
        </article>

        <article className="rounded-xl border-l-4 border-alert bg-white p-4 shadow-sm sm:p-5" data-id="element-149" data-mp="20e3o1omraszu">
          <h2 className="flex items-start gap-2 text-xl text-navy sm:text-2xl" data-id="element-150" data-mp="25cy80twgmnlj">
            <FrownIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-151" data-mp="2t17ln8jis51l" />
            STOP DIAGNOSING EVERY FAULT FROM SCRATCH
          </h2>
          <p className="mt-2 text-sm font-medium leading-snug text-ink/80 sm:text-base" data-id="element-152" data-mp="2jc7idcxzinhl">
            You already know automotive repair. The problem is wasting time
            jumping between possible causes without a clear diagnostic sequence.
            Open the system, identify the symptom and follow the relevant tests.
          </p>
          <p className="mt-1.5 font-display text-lg uppercase tracking-wide text-auto" data-id="element-153" data-mp="3gsd13mljsvbd">
            Less guessing. More structured diagnosis.
          </p>
        </article>
      </div>
    </section>;
}